"use client";

import dynamic from "next/dynamic";

import { useReducedEnvironment } from "@/hooks/usePerformancePreferences";

// BgParticles 2D canvas — three.js değil, dolayısıyla küçük (~3-4 KB gz),
// ama yine de hero dışına sızmaması + reduced-motion/data kullanıcılarına
// hiç indirilmemesi için lazy load ediyoruz.
const BgParticles = dynamic(
  () => import("./BgParticles").then((mod) => mod.BgParticles),
  { ssr: false, loading: () => null },
);

export function BgParticlesLoader() {
  const reduced = useReducedEnvironment();

  // SSR veya reduced ortamda hiç yükleme → client bundle'ından komple çıkar.
  if (reduced === null || reduced) return null;
  return <BgParticles />;
}
